import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import cx from 'classnames';
import Isvg from 'react-inlinesvg';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';
import { messages } from 'features/Search/Search.messages';
import css from '../Search.scss';

export const Pagination = ({
  currentPage,
  extraClass,
  hasNextPage,
  loading,
  onNextClicked,
  onNextLinkTo,
  onPreviousClicked,
  onPreviousLinkTo,
  pageCount,
}) => (
  <div className={cx(css.Search__pagination, extraClass)}>
    <p>
      {pageCount ? (
        <LocalizableMessage message={messages.paginationPageCount} values={{ currentPage, pageCount }} />
      ) : (
        <LocalizableMessage message={messages.pagination} values={{ currentPage }} />
      )}
    </p>
    <Link
      to={onPreviousLinkTo}
      onClick={loading ? () => {} : onPreviousClicked}
      className={cx(
        'disclosure-arrow disclosure-arrow--secondary disclosure-arrow--previous',
        css.Search__pagination__arrow,
        {
          'disclosure-arrow--disabled': currentPage < 2 || loading,
        }
      )}>
      <Isvg className="svg" uniquifyIDs={false} src={require('static/img/arrow.svg')} />
    </Link>
    <Link
      to={onNextLinkTo}
      onClick={loading ? () => {} : onNextClicked}
      className={cx(
        'disclosure-arrow disclosure-arrow--secondary disclosure-arrow--next',
        css.Search__pagination__arrow,
        {
          'disclosure-arrow--disabled': !hasNextPage || loading,
        }
      )}>
      <Isvg className="svg" uniquifyIDs={false} src={require('static/img/arrow.svg')} />
    </Link>
  </div>
);

const LinkToType = PropTypes.shape({
  query: PropTypes.object,
  hash: PropTypes.string,
});

Pagination.propTypes = {
  currentPage: PropTypes.number,
  extraClass: PropTypes.string,
  hasNextPage: PropTypes.bool,
  loading: PropTypes.bool,
  onNextClicked: PropTypes.func.isRequired,
  onNextLinkTo: LinkToType,
  onPreviousClicked: PropTypes.func.isRequired,
  onPreviousLinkTo: LinkToType,
  pageCount: PropTypes.number,
};

Pagination.defaultProps = {
  loading: false,
};
